module.exports = __webpack_public_path__ + "img/gb-eng.7caecb78.svg";